var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_1060)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_801_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7094 11.3396V23.1516C27.8359 22.6375 26.8204 22.4316 25.8204 22.5658C24.8204 22.7 23.8918 23.1668 23.1786 23.8939C22.4654 24.6209 22.0075 25.5675 21.8758 26.5869C21.7442 27.6062 21.9462 28.6414 22.4505 29.5318C22.9549 30.4222 23.7333 31.1181 24.6652 31.5116C25.597 31.905 26.6302 31.974 27.6044 31.7079C28.5787 31.4418 29.4395 30.8554 30.0535 30.0397C30.6675 29.224 31.0003 28.2245 31.0003 27.1964V3.67049C31.0006 3.37072 30.9302 3.07527 30.795 2.80909C30.6597 2.5429 30.4636 2.3138 30.2233 2.14113C29.9829 1.96846 29.7053 1.85728 29.4139 1.817C29.1225 1.77671 28.8258 1.8085 28.549 1.90967L13.8872 7.24817C13.5318 7.37808 13.2244 7.61673 13.007 7.93149C12.7897 8.24625 12.6731 8.62175 12.673 9.00666V25.4846C11.7996 24.9705 10.7842 24.7646 9.78434 24.8988C8.78443 25.0329 7.85588 25.4996 7.14266 26.2264C6.42945 26.9533 5.97142 27.8997 5.8396 28.919C5.70779 29.9382 5.90955 30.9733 6.4136 31.8638C6.91765 32.7542 7.69584 33.4503 8.62747 33.844C9.55911 34.2377 10.5921 34.3071 11.5664 34.0413C12.5406 33.7756 13.4017 33.1896 14.016 32.3743C14.6302 31.5589 14.9635 30.5597 14.9639 29.5317V16.3442L28.7094 11.342V11.3396Z",
    fill: "#00067E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.399902)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_801_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.eb4311df88a3c69fd416f83b7f3c0acc.svg";
export { ForwardRef as ReactComponent };